import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Youtube, Twitter, Linkedin } from 'lucide-react';
import sdoxImage from '@/pages/home/newLogo.png';


const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: t('footer.product'), path: '/product' },
      { label: t('footer.templates'), path: '/project-settings' },
      { label: t('footer.requestDemo'), path: '/free-trial' },
    ],
    company: [
      { label: t('footer.about'), path: '/about' },
      { label: t('footer.contact'), path: '/free-trial' },
    ],
  };

  const socialLinks = [
    { icon: Youtube, label: 'YouTube', href: 'https://www.youtube.com' },
    { icon: Twitter, label: 'Twitter', href: 'https://www.twitter.com' },
    { icon: Linkedin, label: 'LinkedIn', href: 'https://www.linkedin.com' },
  ];

  return (
    <footer className="bg-slate-900">
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <span className="text-xl font-bold text-white">SystemDox</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              {t('footer.tagline')}
            </p>
            {/* Social Links */}
            {/* <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
                  aria-label={social.label}
                >
                  <social.icon size={20} />
                </a>
              ))}
            </div> */}
          </div>

          {/* Product Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.product')}</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-400 text-sm">
              &copy; {currentYear} SystemDox. {t('footer.allRightsReserved')}
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/privacy"
                className="text-slate-400 hover:text-white text-sm transition-colors"
              >
                {t('footer.privacyPolicy')}
              </Link>
              <Link
                to="/terms"
                className="text-slate-400 hover:text-white text-sm transition-colors"
              >
                {t('footer.termsOfService')}
              </Link>
              <Link
                to="/retention"
                className="text-slate-400 hover:text-white text-sm transition-colors"
              >
                Data Retention
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
